import { find, map, uniqueId } from "lodash";
import React from "react";
import { useWinRateBreadcrumbs } from "@/components/layouts/WinRate/WinRateBreadcrumbsContext";
import UserAvatar from "@/components/controls/UserAvatar";
import Text from "@/components/ui/text";
import { Progress } from "@/components/ui/progress";
import DrilldownChart from "./DrilldownChart";
import { reducePrecision } from "@/utils/numbers";
import Spinner from "@/components/ui/spinner";

export type WinRateDrilldownUsersDataType = {
  id: string;
  percentage: number;
  color: string;
}[];

export type WinRateDrilldownChartDataType = {
  date: string;
  [key: string]: string | number;
};
[];

const GRAPH_HEIGHT = 250;

const WinRateDrilldownContent: React.FC = () => {
  const { dynamicTableData, handleRowClick, directReportsData, isLoading } =
    useWinRateBreadcrumbs();

  if (isLoading) {
    return (
      <div className="flex w-full min-h-[17rem] flex-grow items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  return (
    <div className="flex w-full flex-grow">
      <div className="flex flex-1 flex-col gap-2 w-fit">
        {map(dynamicTableData, (directReport) => {
          const userData = find(
            dynamicTableData,
            (user) => user.id === directReport?.id
          );
          const winRatePercentage = directReport.id
            ? reducePrecision(
                directReportsData?.overall.winRates[directReport.id] || 0,
                0
              )
            : 0;
          return (
            <div
              key={uniqueId()}
              className="flex max-h-12 items-center pl-4"
              onClick={() => handleRowClick(directReport)}
            >
              <div className="w-52 h-fit">
                <div className="flex gap-2 w-fit px-2 py-1 rounded-lg cursor-pointer hover:bg-surface-hover">
                  <UserAvatar userData={directReport} size="M" />
                  <Text as="div" variant="body">
                    {directReport?.displayName}
                  </Text>
                </div>
              </div>
              <div className="w-[calc(90%-17rem)] flex gap-2 items-center">
                <Text
                  as="div"
                  variant="body"
                  className="min-w-6 w-fit text-end"
                >
                  {`${winRatePercentage || 0}%`}
                </Text>
                <Progress
                  value={winRatePercentage || 0}
                  staticColor={userData?.color || "#DB21B2"}
                />
              </div>
            </div>
          );
        })}
      </div>
      <div className="flex-1 pb-4 pr-4">
        {directReportsData?.overTime.byMonth && (
          <DrilldownChart height={GRAPH_HEIGHT} />
        )}
      </div>
    </div>
  );
};

export default WinRateDrilldownContent;
